// 配列Aから、配列Bとidが一致する要素をフィルタリングする
export const findCommonElementsById = (arrayA = [], arrayB = []) => {
  return arrayA.filter((itemA) => {
    // 配列Bの中で、itemAと同じidを持つ要素が存在するかをチェック
    const isMatch = arrayB.some((itemB) => itemB.id === itemA.id);
    return isMatch;
  });
};

export const buildUserOptionLabel = (user) => {
  return (
    (user.department ? user.department + " " : "") +
    (user.position ? user.position + " " : "") +
    user.name +
    "(" +
    user.eMailAddress +
    ")"
  );
};
